import { useQuery } from '@tanstack/react-query'
import { getDimensionTree } from '../components/utils'
import { getDimensionOptions } from './getDimensionOptions'

export const useCompanyDimensionTree = (companyId?: string) => {
  const options = getDimensionOptions(companyId, getDimensionTree)
  return useQuery(options)
}
